/**
 * Merge Approvals API — owner-audited merge approval management.
 */

import { apiClient } from "./client";

export interface MergeApproval {
  id: string;
  node_id: string;
  node_path: string;
  old_value: number | null;
  new_value: number | null;
  old_units: string | null;
  new_units: string | null;
  change_reason: string | null;
  required_approver: string;
  status: "pending" | "approved" | "rejected" | "waived";
  reviewed_by: string | null;
  reviewed_at: string | null;
  review_comment: string | null;
  created_at: string;
}

export function fetchPendingApprovals(
  projectId: string,
  sourceBranch: string,
  targetBranch: string,
): Promise<MergeApproval[]> {
  const params = new URLSearchParams({
    project_id: projectId,
    source_branch: sourceBranch,
    target_branch: targetBranch,
  });
  return apiClient<MergeApproval[]>(`/versioning/merge/approvals?${params}`);
}

export function fetchAllApprovals(
  projectId: string,
  sourceBranch: string,
  targetBranch: string,
): Promise<MergeApproval[]> {
  const params = new URLSearchParams({
    project_id: projectId,
    source_branch: sourceBranch,
    target_branch: targetBranch,
    include_resolved: "true",
  });
  return apiClient<MergeApproval[]>(`/versioning/merge/approvals?${params}`);
}

export function approveChange(approvalId: string): Promise<MergeApproval> {
  return apiClient<MergeApproval>(
    `/versioning/merge/approvals/${approvalId}/approve`,
    { method: "POST" },
  );
}

export function rejectChange(
  approvalId: string,
  comment = "",
): Promise<MergeApproval> {
  const params = new URLSearchParams({ comment });
  return apiClient<MergeApproval>(
    `/versioning/merge/approvals/${approvalId}/reject?${params}`,
    { method: "POST" },
  );
}

export function waiveApproval(approvalId: string): Promise<MergeApproval> {
  return apiClient<MergeApproval>(
    `/versioning/merge/approvals/${approvalId}/waive`,
    { method: "POST" },
  );
}
